// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"27d4c75b","201":"b85c30e5","211":"eef1d281","576":"93d9ccfe","679":"acfea4a7","886":"c1aa0dd5"}[chunkId] + ".css";
};